import classNames from "classnames";
import React, { forwardRef } from "react";
import IBuildrProps from "../../../utilities/IBuildrProps";
import styled from "styled-components";

interface IFormCheckboxProps extends IBuildrProps {
    value: any;
    id: string;
    onChange: (e: any) => void;
    label: string;
    inputClassName?: string;
    labelClassName?: string;
}

const CheckboxContainer = styled.div`

    [type="checkbox"]:not(:checked),
    [type="checkbox"]:checked {
        position: absolute;
        left: 0;
        top:5;
        opacity: 0;
    }

    [type="checkbox"]:checked+.checkmark {
        background-color: #3F94FD;
    }

    .checkmark {
        position: absolute;
        left: 0;
        top: 5px;
        background-color: #e4e5e6;
        height: 14px;
        width: 14px;
        cursor: pointer;
        border-radius: 3px;
    }

    [type="checkbox"]:checked+.checkmark:after {
        width: 5px;
        height: 9px;
        border: solid white;
        border-width: 0 2px 2px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
        content: "";
        margin-left: 4.5px;
        margin-bottom: 7px;
        display: inline-block;
    }
  
    /* Disabled checkbox */
    [type="checkbox"]:disabled:not(:checked) + label:before,
    [type="checkbox"]:disabled:checked + label:before {
        box-shadow: none;
        border-color: #bbb;
        background-color: #e9e9e9;
    }

    [type="checkbox"]:disabled:checked + label:after {
        color: #777;
    }

    [type="checkbox"]:disabled + label {
        color: #aaa;
    }

    .form-check-label {
        font-size: 15px;
    }
`;

const FormCheckbox = forwardRef(({ inputClassName, labelClassName, label, value, id = "checkbox", onChange, cmsId, editorClassObj }: IFormCheckboxProps, ref: any) => {
    return (
        <CheckboxContainer className={classNames("form-group form-check", editorClassObj)} data-id={cmsId} ref={ref}>
            <input type="checkbox" value={value} onChange={onChange} className={classNames(inputClassName, "form-check-input")} id={id} />
            <label htmlFor={id} className="checkmark"></label>
            <label className={classNames(labelClassName, "form-check-label ml-2 font-weight-bold")} >{label}</label>
        </CheckboxContainer>
    );
});

export default FormCheckbox;